
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTwowayAcuatorPiston10 as ObiTwowayAcuatorPiston10Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-twoway-acuator-piston-10.js';
 
 
 

 
 export const ObiTwowayAcuatorPiston10 = createComponent({
   react: React,
   tagName: 'obi-twoway-acuator-piston-10',
   elementClass: ObiTwowayAcuatorPiston10Element,
   events: {
     
   }
  });
 
 